if (!customElements.get('natunora-solution-video')) {
  customElements.define('natunora-solution-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.update = () => {
        if (this.motion.matches || document.hidden) this.video.pause();
        else this.video.play().catch(() => {});
      };
      this.motion.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);
      this.update();
    }
    disconnectedCallback() {
      if (!this.video) return;
      this.video.pause();
      this.motion.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
    }
  });
}
